import React from "react";
import { useNavigate} from "react-router-dom";
import { Trans } from 'react-i18next';

import {
     Button, Words, Project, Blockquote,Puffs

} from 'arwes';
import error from "../Error/ErrorBoundary";


const HomePage = () => {


    const setNavigate = useNavigate()
    const readingMyths = () =>{
       setNavigate("/myths")
    }
    const readingCategory = () => {
        setNavigate("/category")

    }



    return(

        <div  style={{ margin: 20 }}>
            <Puffs>
            <div>

                <Blockquote ><Trans>Home</Trans> </Blockquote>
            </div>
            <div className="col-xs-12 col-md-12 col-lg-12"  >
                <div className="row">
                    <Project
                        className=""
                         animate
                        header="Science Fiction"
                        >
                            { anim => (
                            <p ><Trans>
                                According to Wikipedia,Science fiction is a genre of speculative fiction which typically deals with imaginative
                            and futuristic concepts such as advanced science and technology, space exploration, time travel, parallel universes, and extraterrestrial life. It has been called the "literature of ideas",
                            and it often explores the potential consequences of scientific, social, and technological innovations

                            </Trans>
                            </p>
                            )}
                    </Project>


                    <Project
                        className=""
                        animate
                        header="Sci-Fiction latest News"
                        style={{ padding: 20 }}
                        >
                        { anim => (
                            <p ><Trans>
                              Check the latest news About Science-Fictions and also its applications
                                and you could realise that it's not as fiction
                            </Trans>

                                <br/> <br/>
                                <Button align="center" animate><Trans>Read More</Trans></Button>

                            </p>
                        )}
                    </Project>
                        <Project
                            className=""
                            animate
                            header="Sci-Fi Categories News"
                            style={{ padding: 20 }}
                            >
                            { anim => (
                                <p ><Trans>
                                    Check the latest news About Science-Fictions according to category and how it could serve humanity
                                    </Trans>
                                    <br/> <br/>
                                    <Button align="center" onClick={readingCategory} animate><Trans>Read More</Trans></Button>
                                </p>
                            )}
                        </Project>
                    </div>




                <div className="row">
                    <Project
                        className="col-xs-12 col-md-12 col-lg-12"
                        animate
                        header="Sci-Fi Myths"
                        style={{ padding: 20 }}
                    >
                        { anim => (
                            <p ><Trans>
                                But first of all let check what SCI-FI is not about or what you could heard about SCI-FI that is not true
                                </Trans>
                                <br/> <br/>
                                <Button align="center" onClick={readingMyths}  animate><Trans>Read More</Trans></Button>
                            </p>
                        )}
                    </Project>
                </div>
            </div>
            </Puffs>

        </div>
    )
}
export default HomePage
